import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import TrialExpired from "../pages/TrialExpired";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="flex items-center justify-center h-screen text-zinc-500" data-testid="auth-loading">
        Lade…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/passwort-aendern" replace />;
  // Trial abgelaufen → Sperr-Screen (außer Plattform-Superadmin)
  if (user.trial_expired && !user.is_superadmin) return <TrialExpired />;
  return children;
}
